import { Form, Row, Col } from 'react-bootstrap';
import PincodeSelector from '../../PincodeSelector'; // TEMPORARY: Using pincode-first approach
// import TownSelector from '../../TownSelector'; // ORIGINAL: Town-first approach
import { isValidPincode } from '../../../common/validators';

function AddressForm({ form, setForm, stepSubmitted }) {
    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    return (
        <div className="mb-4">
            <Row>
                <Col md={12} xl={12}>
                    <Form.Group className="mb-2">
                        <Form.Label>Full Address <span className="text-danger">*</span></Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            name="address"
                            value={form.address}
                            onChange={handleChange}
                            required
                            isInvalid={stepSubmitted && !form.address}
                        />
                        <Form.Control.Feedback type="invalid">
                            Address is required.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>

                <Col md={6} xl={3}>
                    <Form.Group className="mb-2">
                        <Form.Label>Pincode <span className="text-danger">*</span></Form.Label>
                        <PincodeSelector form={form} setForm={setForm} stepSubmitted={stepSubmitted} />
                        {stepSubmitted && !form.pin_code && (
                            <div className="invalid-feedback d-block">Pincode is required.</div>
                        )}
                    </Form.Group>
                </Col>

                <Col md={6} xl={3}>
                    <Form.Group className="mb-2">
                        <Form.Label>Town <span className="text-danger">*</span></Form.Label>
                        <Form.Control
                            name="town"
                            value={form.town}
                            readOnly
                            isInvalid={stepSubmitted && !form.town}
                        />
                        <Form.Control.Feedback type="invalid">
                            Town is required.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>

                <Col md={6} xl={3}>
                    <Form.Group className="mb-2">
                        <Form.Label>City <span className="text-danger">*</span></Form.Label>
                        <Form.Control
                            name="city"
                            value={form.city}
                            readOnly
                            isInvalid={stepSubmitted && !form.city}
                        />
                        <Form.Control.Feedback type="invalid">
                            City is required.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>

                <Col md={6} xl={3}>
                    <Form.Group className="mb-2">
                        <Form.Label>State <span className="text-danger">*</span></Form.Label>
                        <Form.Control
                            name="state"
                            value={form.state}
                            readOnly
                            isInvalid={stepSubmitted && !form.state}
                        />
                        <Form.Control.Feedback type="invalid">
                            State is required.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>
        </div>
    );
}

AddressForm.validate = function (form) {
    return (
        !!form.address &&
        !!form.state &&
        !!form.pin_code &&
        !!form.city &&
        !!form.town &&
        isValidPincode(form.pin_code)
    );
};

export default AddressForm;
